import alt from "../alt";

class EventBucketActions {
  constructor() {
    this.generateActions(
      "create",
      "delete",
      "updateEventBuckets",
      "fetchAll",
      "fetchOne",
      "fetchFailed",
      "editFailed",
      "fetchConfigSchema"
    );
  }

  updateEventBucket(id, eventBucket) {
    return { id, eventBucket };
  }

  edit(id, values) {
    return { id, values };
  }

  uploadFile(id, key, file, callback) {
    return { id, key, file, callback };
  }

  testSubdomain(id, subdomain) {
    return { id, subdomain };
  }

  duplicate(id, options) {
    options.id = id;
    return options;
  }
}

export default alt.createActions(EventBucketActions);



// WEBPACK FOOTER //
// ./src/app/actions/EventBucketActions.js